let wavesurfer = null,
    waveformText = '',
    soundbar = null;

addEventListener("DOMContentLoaded", (event) => {
    const container = document.querySelector('#waveform');
    soundbar = document.querySelector('.soundbar');
    waveformText = document.querySelector('.waveform__track-details');
    wavesurfer = WaveSurfer.create({
        container: container,
        waveColor: 'rgb(255 255 255)',
        progressColor: 'rgb(42 42 42)',
        cursorColor: 'rgb(255 215 55)',
        barWidth: 2,
        barHeight: 0.9,
        barGap: 2,
        height: 50,
        responsive: true,
        normalize: true,
        backend: 'WebAudio',
    });

    const trackName = document.querySelector('.soundbar__track-name');

    document
        .querySelector('[data-action="play"]')
        .addEventListener('click', wavesurfer.playPause.bind(wavesurfer));

    document
        .querySelector('[data-action="next"]')
        .addEventListener('click', nextTrack);

    document
        .querySelector('[data-action="previous"]')
        .addEventListener('click', previousTrack);

    wavesurfer.on('play', function() {
        console.log('wavesurfer.on(\'play\')');
        const pauseVideosEvent = new Event('videos:pause');
        const pauseProductAudioEvent = new Event('product:audio:pause');
        const playCollectionBannerAudioEvent = new Event('collection-banner:audio:play');
        document.dispatchEvent(pauseVideosEvent);
        document.dispatchEvent(pauseProductAudioEvent);
        document.dispatchEvent(playCollectionBannerAudioEvent);

        document.querySelector('#play').style.display = 'none';
        document.querySelector('#pause').style.display = 'inline-block';
    });

    wavesurfer.on('pause', function() {
        const pauseCollectionBannerAudioEvent = new Event('collection-banner:audio:pause');
        document.dispatchEvent(pauseCollectionBannerAudioEvent);

        document.querySelector('#play').style.display = 'inline-block';
        document.querySelector('#pause').style.display = 'none';
    });

    wavesurfer.on('finish', function() {
        nextTrack();
    });

    document.querySelector('.waveform__close').addEventListener('click', function() {
        soundbar.classList.remove('active');
        wavesurfer.pause();
    });

    document.addEventListener('soundbar:pause', function() {
        soundbar.classList.remove('active');
        wavesurfer.pause();
    });

    wavesurfer.on('error', function(e) {
        console.warn(e);
    });

    window.initiateAudioTracks();
});

window.initiateAudioTracks = function() {
    const soundbar = document.querySelector('.soundbar');

    [...document.querySelectorAll('[data-track] [data-action="initiate"]')].forEach(function (e) {
        e.dataset.action = "";
        e.addEventListener('click', function () {
            const smile = document.getElementById('smile-ui-container');
            if (smile) {
                document.getElementById('smile-ui-container').style.zIndex = '99';
            }
            let audioContainer = e.parentElement;
            soundbar.classList.add('active');
            loadTrack(audioContainer);
        })
    });
}

window.loadTrack = async function (element) {
    const progressColor = element.dataset.progressColor;
    const waveColor = element.dataset.waveColor;

    wavesurfer.setOptions({
        progressColor: progressColor,
        waveColor: waveColor
    });

    if (!soundbar.classList.contains('active')) {
        soundbar.classList.add('active');
    }

    [...document.querySelectorAll('.player__audio')].forEach(function (element) {
        element.classList.remove('active');
    });

    element.classList.add('active');

    if (element.classList.contains('soundbar__tab-menu-item')) {
        [...document.querySelectorAll('.soundbar__tab-menu-item')].forEach(function (element) {
            element.classList.remove('active');
        });
        element.classList.add('active');
    }

    let trackContainer = element.parentElement;
    let trackCount = ~~trackContainer.dataset.track_count;
    let currentTrackUrl = element.dataset.track;
    let currentTrackPeaksUrl = currentTrackUrl.replace('.mp3', '.mp3.json');
    let currentPosition = ~~element.dataset.track_position

    document.querySelector('.soundbar__link').setAttribute('href', element.dataset.url);

    wavesurfer.pause();
    wavesurfer.seekTo(0);

    // Fetch peaks for visualization
    await fetch(currentTrackPeaksUrl)
        .then(response => response.json())
        .then(peaks => {
            wavesurfer.load(currentTrackUrl, peaks.data, peaks.data.length);
            wavesurfer.play();
        })
        .finally(() => {
            updateTrackInfo(element, currentPosition);
        })
        .catch(e => console.error('Error fetching peaks:', e));
}

function previousTrack() {
    const tracks = document.querySelectorAll('.player__audio:not(.player__audio_collection_banner)');
    const trackCount = tracks.length;
    const active = document.querySelector('.player__audio.active:not(.player__audio_collection_banner)');
    const index = [...tracks].indexOf(active);
    const activeTrack = index === 0 ? tracks[(trackCount - 1)] : tracks[(index - 1)];

    active.classList.remove('active');
    activeTrack.classList.add('active');
    trackSkip(activeTrack);
}

function nextTrack() {
    const tracks = [...document.querySelectorAll('div:not(.product-info__sticky) > .player__audio:not(.player__audio_collection_banner)')].filter(player =>
        player.querySelector('button')
    );
    const trackCount = tracks.length;
    const active = document.querySelector('div:not(.product-info__sticky) > .player__audio.active:not(.player__audio_collection_banner)');
    const index = [...tracks].indexOf(active);
    const activeTrack = index === (trackCount - 1) ? tracks[0] : tracks[index + 1];

    active?.classList.remove('active');
    activeTrack.classList.add('active');
    trackSkip(activeTrack);
}

async function trackSkip(activeTrack) {
    const activeTrackPeaksUrl = activeTrack.dataset.track.replace('.mp3', '.mp3.json');
    const progressColor = activeTrack.dataset.progressColor;
    const waveColor = activeTrack.dataset.waveColor;

    wavesurfer.pause();
    wavesurfer.seekTo(0);

    wavesurfer.setOptions({
        progressColor: progressColor,
        waveColor: waveColor
    });

    // Fetch peaks for visualization
    await fetch(activeTrackPeaksUrl)
        .then(response => response.json())
        .then(peaks => {
            wavesurfer.load(activeTrack.dataset.track, peaks.data, peaks.data.length);
            wavesurfer.play();
        })
        .finally(() => {
            updateTrackInfo(activeTrack);
        })
        .catch(e => console.error('Error fetching peaks:', e));

    wavesurfer.on('ready', function () {
        wavesurfer.play();
    });
}

function updateTrackInfo(trackData) {
    document.querySelector('.soundbar__record-name').textContent = trackData.dataset.record_name;
    document.querySelector('.soundbar__track-image').src = trackData.dataset.record_cover;
    waveformText.textContent = trackData.dataset.record_name;
}